angular.module('galilai.creator').controller('GeneratorController', function($timeout, $scope, api, generator, $rootScope, topics) {
    console.log('GeneratorController');

    const GENERATE_AMOUNT = 5
    const MAX_MEDIA_ITEMS = 10
    let _generator = generator()
    $scope.generator = _generator
    $scope.topics = topics

    const modesWithTabsVisible = ['themes', 'instruction', 'media', 'product']
    const modesWithIncludeProfile = ['instruction', 'themes']
    const modesWithTones = ['instruction', 'themes', 'dates']
    const objectivesWithTones = ['authority']
    const modesWithContentTypes = ['instruction', 'themes']

    const DEFAULT_POST_FORMATS = [
        { value: 'post', label: gettext('generator.post_format_post') },
        { value: 'story', label: gettext('generator.post_format_story') },
        { value: 'reels', label: gettext('generator.post_format_reels') },
    ]
    const DEFAULT_STATE = {
        allSelected: false,
        step: 'home',
        mode: 'themes',
        tab: 'content',
        current: null,
        inputs: {
            shouldExpand: 'yes',
            includeProfile: 'yes',
            tone: 'normal',
            size: 'medium',
            objective: 'authority',
            sales_content_type: ['hooks', 'benefits', 'offers', 'cta', 'social_proof'],
            authority_content_type: ['list', 'opinion', 'question', 'checklist', 'news', 'trivia', 'tips', 'myths', 'errors'],
            mediaFormat: 'image',
            hasCaption: 'no',
            postFormat: 'post',
        },
        loadedInputs: {},
        inputsByMode: {},
    }

    $scope.state = JSON.parse(JSON.stringify(DEFAULT_STATE))

    const allInputs = ['context', 'shouldExpand', 'tone', 'objective', 'format', 'sales_content_type', 'authority_content_type', 'size', 'audience', 'includeProfile']

    const visibilityForms = {
        'themes': ['related', 'expanded', 'tone', 'objective', 'format', 'sales_content_type', 'authority_content_type', 'size', 'layouts', 'audience', 'includeProfile'],
        'instruction': ['related', 'expanded', 'tone', 'objective_custom', 'format', 'sales_content_type', 'authority_content_type', 'size', 'layouts', 'audience', 'includeProfile', 'context'],
        'instruction_custom': ['objective_custom', 'alert_custom', 'layouts', 'includeProfile', 'context'],
        'media': ['layouts', 'context'],
        'product': ['layouts', 'context'],
        'dates': ['context'],
    }

    const visibilityFormsPerTab = {
        'context': 'content',
        'layouts': 'settings',
        'related': 'content',
        'includeProfile': 'settings',
        'expanded': 'content',
        'tone': 'settings',
        'audience': 'settings',
        'objective': 'content',
        'objective_custom': 'content',
        'format': 'content',
        'sales_content_type': 'content',
        'authority_content_type': 'content',
        'size': 'settings',
        'alert_custom': 'content',
    }

    $scope.smartFiltersMap = {
        grid: ['vertical', 'horizontal'],
        style: ['geometric', 'rounded'],
        shader: ['flat', '3d'],
        orientation: ['begin', 'end'],
        focus: ['text', 'balanced', 'fullscreen'],
        //alignment: ['left', 'center', 'right'],
        decorative: ['no', 'yes'],
        include_shapes: ['no', 'yes'],
    }

    $scope.smartFilters = {
        inputs: [
        ],
        values: {
        }
    }

    function buildSmartFilters() {
        if (!safeGetStorage('layouts.seed')) {
            safeSetStorage('layouts.seed', Math.floor(Math.random() * 1000000))
        }
        for (let key in $scope.smartFiltersMap) {
            let values = $scope.smartFiltersMap[key]
            let filter = {
                label: gettext('layout.smart_title_' + key),
                id: key,
                values: [
                    {
                        label: gettext('layout.smart_any'),
                        value: 'any'
                    }
                ]
            }
            values.forEach(function(value) {
                filter.values.push({
                    label: gettext('layout.smart_'+ value),
                    value: value
                })
            })
            $scope.smartFilters.inputs.push(filter)
            $scope.smartFilters.values[key] = 'any'
        }
    }
    buildSmartFilters()

    $scope.forms = {
        expanded: {
            id: 'shouldExpand',
            tooltip: gettext('generator.include_related_tooltip'),
            label: gettext('generator.include_related'),
            values: [
                { value: 'no', label: gettext('generic.no') },
                { value: 'yes', label: gettext('generic.yes') },
            ]
        },
        includeProfile: {
            id: 'includeProfile',
            tooltip: gettext('generator.include_profile_tooltip'),
            label: gettext('generator.include_profile'),
            values: [
                { value: 'no', label: gettext('generic.no') },
                { value: 'yes', label: gettext('generic.yes') },
            ]
        },
        tone: {
            id: 'tone',
            tooltip: gettext('generator.tone_tooltip'),
            label: gettext('generator.tone'),
            values: [
                { value: 'normal', label: gettext('generator.tone_normal') },
                { value: 'curious', label: gettext('generator.tone_curious') },
                { value: 'fun', label: gettext('generator.tone_fun') },
                { value: 'polemic', label: gettext('generator.tone_polemic') },
                { value: 'inspiring', label: gettext('generator.tone_inspiring') },
                { value: 'formal', label: gettext('generator.tone_formal') },
                { value: 'informal', label: gettext('generator.tone_informal') },
                { value: 'informative', label: gettext('generator.tone_informative') },
            ]
        },
        objective: {
            id: 'objective',
            tooltip: gettext('generator.objective_tooltip'),
            label: gettext('generator.objective'),
            values: [
                { value: 'authority', label: gettext('generator.objective_authority') },
                { value: 'sales', label: gettext('generator.objective_sales') },
            ]
        },
        objective_custom: {
            id: 'objective',
            tooltip: gettext('generator.objective_tooltip'),
            label: gettext('generator.objective'),
            values: [
                { value: 'authority', label: gettext('generator.objective_authority') },
                { value: 'sales', label: gettext('generator.objective_sales') },
                { value: 'custom', label: gettext('generator.objective_custom') },
            ]
        },
        authority_content_type: {
            id: 'authority_content_type',
            label: gettext('generator.content_type'),
            values: [
                { value: 'list', label: gettext('generator.authority_list') },
                { value: 'opinion', label: gettext('generator.authority_opinion') },
                { value: 'question', label: gettext('generator.authority_question') },
                { value: 'checklist', label: gettext('generator.authority_checklist') },
                { value: 'news', label: gettext('generator.authority_news') },
                { value: 'trivia', label: gettext('generator.authority_trivia') },
                { value: 'tips', label: gettext('generator.authority_tips') },
                //{ value: 'tutorial', label: gettext('generator.authority_tutorial') },
                { value: 'myths', label: gettext('generator.authority_myths') },
                { value: 'errors', label: gettext('generator.authority_errors') },
            ]
        },
        sales_content_type: {
            id: 'sales_content_type',
            label: gettext('generator.content_type'),
            values: [
                { value: 'hooks', label: gettext('generator.sales_hooks') },
                { value: 'benefits', label: gettext('generator.sales_benefits') },
                //{ value: 'features', label: gettext('generator.sales_features') },
                { value: 'offers', label: gettext('generator.sales_offers') },
                { value: 'cta', label: gettext('generator.sales_cta') },
                { value: 'social_proof', label: gettext('generator.sales_social_proof') },
            ]
        },
        size: {
            id: 'size',
            label: gettext('generator.size'),
            values: [
                { value: 'short', label: gettext('generator.size_short') },
                { value: 'medium', label: gettext('generator.size_medium') },
                { value: 'long', label: gettext('generator.size_long') },
            ]
        },
        mediaFormat: {
            id: 'mediaFormat',
            label: gettext('generator.media_format'),
            values: [
                { value: 'image', label: gettext('generator.media_format_image') },
                { value: 'video', label: gettext('generator.media_format_video') },
            ]
        },
        hasCaption: {
            id: 'hasCaption',
            label: gettext('generator.hasCaption'),
            values: [
                { value: 'no', label: gettext('generic.no') },
                { value: 'yes', label: gettext('generic.yes') },
            ]
        },
        postFormat: {
            id: 'postFormat',
            label: gettext('generator.post_format'),
            values: JSON.parse(JSON.stringify(DEFAULT_POST_FORMATS)),
        }
    }

    $scope.productInputs = {
        objective: {
            value: 'any',
            label: gettext('gen.product.objective'),
            values: ['price', 'discount', 'info', 'cta'],
        },
    }

    function buildInputs() {
        $scope.productInputs.objective.values = $scope.productInputs.objective.values.map(function(value) {
            return {
                value: value,
                label: gettext('gen.product.' + value),
            }
        })
        $scope.productInputs.objective.values.unshift({
            value: 'any',
            label: gettext('layout.smart_any'),
        })
    }

    buildInputs()

    let timerInputs = null
    function onInputsChanges() {
        if ($scope.state.step != 'inputs') {
            return
        }
        if (timerInputs) {
            $timeout.cancel(timerInputs)
        }
        timerInputs = $timeout(function() {
            $scope.saveUserInputs()
        }, 500)
    }
    $scope.$watch('state.inputs', onInputsChanges, true)
    $scope.$watch('smartFilters.values', onInputsChanges, true)

    $scope.modes = [
        { name: gettext('label.mode_themes'), value: 'themes', description: gettext('label.mode_themes_description'), enabled: true },
        { name: gettext('label.mode_instruction'), value: 'instruction', description: gettext('label.mode_instruction_description'), enabled: true },
        { name: gettext('label.mode_product'), value: 'product', description: gettext('label.mode_product_description'), enabled: true},
        { name: gettext('label.mode_link'), value: 'link', description: gettext('label.mode_link_description'), enabled: true },
        { name: gettext('label.mode_media'), value: 'media', description: gettext('label.mode_media_description'), enabled: true },
        { name: gettext('label.mode_dates'), value: 'dates', description: gettext('label.mode_dates_description'), enabled: true},
        { name: gettext('label.mode_empty'), value: 'empty', description: gettext('label.mode_empty_description'), enabled: true },
        { name: gettext('label.mode_existing'), value: 'existing', description: gettext('label.mode_existing_description'), enabled: true },

        //{ name: 'Sobre mim/empresa', value: 'aboutMe', description: 'Escolha uma informação sobre você', enabled: false },
        /*
        { name: 'Antes e Depois', value: 'beforeAfter', description: 'Escolha uma imagem de antes e depois' },

        { name: 'Citação', value: 'quote', description: 'Escolha uma citação' },
        { name: 'Pergunta', value: 'question', description: 'Escolha uma pergunta' },
        { name: 'Dica', value: 'tip', description: 'Escolha uma dica' },
        { name: 'Curiosidade', value: 'curiosity', description: 'Escolha uma curiosidade' },
        { name: 'Frase', value: 'sentence', description: 'Escolha uma frase' }*/
        // Desafios/Concursos
        // Testemunhos
        // Bastidores
        // Promoçao
        // Memes
        // Posts educativos
        // FAQ
    ]

    $scope.init = function() {
    }

    $scope.isSettings = function() {
        return $scope.state.tab == 'settings'
    }

    $scope.isContent = function() {
        return $scope.state.tab == 'content'
    }

    $scope.isTabsVisible = function() {
        return modesWithTabsVisible.includes($scope.state.mode)
    }

    $scope.isFieldVisible = function(field) {
        if (visibilityFormsPerTab[field] != $scope.state.tab) {
            return false
        }

        if (field == 'tone' && !objectivesWithTones.includes($scope.state.inputs.objective)) {
            return false
        }

        let mode = $scope.state.mode
        if ($scope.state.inputs.objective == 'custom') {
            mode += '_custom'
        }
        if (!visibilityForms[mode]) {
            return false
        }
        return visibilityForms[mode].includes(field)
    }

    $rootScope.$on('media.selected', function(event, medias, source, actionType) {
        if (source && source.origin != 'generator') {
            return
        }

        if (source?.name == 'selectProducts' || source?.name == 'selectMedias') {
            let keys = {
                'selectMedias': 'medias',
                'selectProducts': 'products',
            }
            let selectedKey = keys[source.name]
            if (!$scope.state.inputs[selectedKey]) {
                $scope.state.inputs[selectedKey] = []
            }
            medias = medias.filter(media => {
                return !$scope.state.inputs[selectedKey].find(p => p._id == media._id)
            })
            $scope.state.inputs[selectedKey] = $scope.state.inputs[selectedKey].concat(medias)
            if ($scope.state.inputs[selectedKey].length >= MAX_MEDIA_ITEMS) {
                $scope.state.inputs[selectedKey] = $scope.state.inputs[selectedKey].slice(0, MAX_MEDIA_ITEMS)
                showError(gettext('error.max_media_items'))
            }
        }
    })

    $rootScope.$on('projectLoaded', function(event) {
        $scope.state = JSON.parse(JSON.stringify(DEFAULT_STATE))
        $scope.generator.reset()
    })

    $rootScope.$on('generator.show', function(event, data) {
        $scope.state.current = data

        angular.element('#generator-modal').modal('show')
        if (data.mode) {
            $scope.state.mode = data.mode
            $scope.state.step = 'inputs'
        }
        if (data.context) {
            $scope.state.inputs.context = data.context
        }
        _generator.update({
            theme: data.theme,
            project: data.project,
            handle: data.handle,
            multiple: data.multiple,
        })
    })

    $scope.isRelatedEnabled = function() {
        return (($scope.state.mode == 'instruction' && $scope.state.inputs.objective != 'custom') || $scope.state.mode == 'themes') && $scope.state.inputs.shouldExpand == 'yes'
    }

    $scope.selectThemes = function() {
        topics.initSelection()
    }

    $scope.editThemes = function() {
        topics.initEditing()
    }

    $scope.selectMode = function(mode) {
        if (!mode.enabled) {
            return
        }
        if (mode.value == 'empty') {
            $rootScope.$broadcast('generator.startFromScratch')
            return
        }
        $scope.state.step = 'inputs'
        $scope.state.mode = mode.value

        $scope.loadUserInputs()
        $scope.onObjectiveChange()
        if (!$scope.isTabsVisible()) {
            $scope.state.tab = 'content'
        }
    }

    $scope.backToSelectMode = function() {
        $scope.state.step = 'home'
        $scope.state.mode = null
    }

    $scope.backState = function() {
        if ($scope.state.step == 'preview') {
            $scope.state.step = 'inputs'
            return
        }
        if ($scope.state.step == 'inputs') {
            $scope.state.step = 'home'
            return
        }
    }

    $scope.getContext = function() {
        let context = $scope.state.inputs.context
        // TODO - Improve
        if ($scope.state.mode == 'themes') {
            return topics.getTopicsForGeneration()
        }
        return context
    }

    $scope.getThemesContext = function() {
        if ($scope.state.mode == 'themes') {
            return topics.getTopicsForGeneration()
        }
        return null
    }

    $scope.suggestTopics = function(topic, kind) {
        _generator.startLoading()
        topics.suggestTopics(topic)
        .then((results) => {
            topics.addTopics(results, kind)
        })
        .catch(function(error) {
            showError(gettext('error.generic'))
        })
        .finally(function() {
            _generator.stopLoading()
        })
    }

    $scope.expandInput = function(input, append=false) {
        $scope.state.tab = 'content'
        _generator.startLoading()
        let context = input
        if (input) {
            context = input
        } else if ($scope.state.mode == 'instruction') {
            context = $scope.state.inputs.context
        } else if ($scope.state.mode == 'themes') {
            context = topics.getTopicsForGeneration()
        }
        api.expandInput({
            context: context,
            profile: $scope.state.current.profile,
            audience: $scope.state.current.audience,
            project: $scope.state.current.project,
            language: $scope.state.current.language,
        })
        .then(function(response) {
            $timeout(function() {
                if (input || append) {
                    $scope.appendToExpanded(response.data.result)
                } else {
                    $scope.updateExpanded(response.data.result)
                }
            }, 0)
        })
        .catch(function(error) {
            console.log('Error expanding input', error)
        })
        .finally(function() {
            _generator.stopLoading()
        })
    }

    $scope.getExpandedKey = function() {
        let keys = [
            $scope.state.inputs.objective,
            topics.topicFilter,
        ]
        for (topic of topics.getCurrentTopics()) {
            keys.push(topic.label)
        }
        return keys.join('_')
    }

    $scope.getExpanded = function() {
        if (!$scope.state.inputs.expanded) {
            return []
        }
        return $scope.state.inputs.expanded[$scope.getExpandedKey()] || []
    }

    $scope.updateExpanded = function(data) {
        let key = $scope.getExpandedKey()
        $scope.state.inputs.expanded = $scope.state.inputs.expanded || {}
        $scope.state.inputs.expanded[key] = data
    }

    $scope.appendToExpanded = function(data) {
        let key = $scope.getExpandedKey()
        $scope.state.inputs.expanded = $scope.state.inputs.expanded || {}
        $scope.state.inputs.expanded[key] = $scope.state.inputs.expanded[key] || []
        $scope.state.inputs.expanded[key] = $scope.state.inputs.expanded[key].concat(data)
    }

    $scope.removeExpandedItem = function(item) {
        let key = $scope.getExpandedKey()
        $scope.state.inputs.expanded[key] = $scope.state.inputs.expanded[key].filter(i => i != item)
    }

    $scope.removeAllExpanded = function() {
        let key = $scope.getExpandedKey()
        $scope.state.inputs.expanded[key] = []
    }

    $scope.clearContext = function() {
        $scope.state.inputs.context = ''
    }

    $scope.saveUserInputs = function() {
        $scope.state.inputsByMode[$scope.state.mode] = JSON.parse(JSON.stringify($scope.state.inputs))

        let defaultSave = [
            'objective',
            'format',
            'sales_content_type',
            'authority_content_type',
            'size',
            'audience',
            'shouldExpand',
        ]
        let whatToSave = {
            'instruction': ['context', 'shouldExpand'].concat(defaultSave),
            'themes': defaultSave,
            'link': ['context', 'link'],
            'product': ['context'],
            'media': ['context'],
            'dates': ['context'],
        }

        let toSave = {}
        if (!whatToSave[$scope.state.mode]) {
            return
        }
        for (let input of whatToSave[$scope.state.mode]) {
            let key = `${$scope.state.mode}.${input}`
            toSave[key] = $scope.state.inputs[input]
        }

        toSave['tone'] = $scope.state.inputs.tone
        toSave['layouts'] = $scope.smartFilters.values

        api.updateProjectInputs($scope.state.current.project, toSave)
        .then(function(response) {
            // Ignore response
        })
        .catch(function(error) {
            console.log('Error saving inputs', error)
        })
    }

    $scope.loadUserInputs = function() {
        for (let input of allInputs) {
            if ($scope?.state?.inputsByMode[$scope.state.mode]?.[input]) {
                $scope.state.inputs[input] = $scope.state.inputsByMode[$scope.state.mode][input]
            }
            if (!$scope?.state?.inputsByMode[$scope.state.mode]?.context) {
                $scope.state.inputs.context = ''
            }
        }
        if ($scope.state.loadedInputs[$scope.state.mode]) {
            return
        }
        $scope.state.loadedInputs[$scope.state.mode] = true
        if ($scope?.state?.current?.global?.inputs[$scope.state.mode]) {
            let inputs = $scope.state.current.global.inputs[$scope.state.mode]
            for (let key in inputs) {
                $scope.state.inputs[key] = inputs[key]
            }
        }
        if ($scope?.state?.current?.global?.inputs?.tone) {
            $scope.state.inputs.tone = $scope.state.current.global.inputs.tone
        }

        if (!$scope?.state?.inputs?.audience && $scope.state.current.audience) {
            $scope.state.inputs.audience = $scope.state.current.audience
        }

        if ($scope?.state?.current?.global?.inputs?.layouts) {
            $scope.smartFilters.values = $scope.state.current.global.inputs.layouts
        }
    }

    $scope.onObjectiveChange = function() {
        if ($scope.state.mode != 'themes') {
            return
        }
        let mapObjectiveSource = {
            'authority': 'default',
            'sales': 'sales',
        }
        if (!mapObjectiveSource[$scope.state.inputs.objective]) {
            return
        }
        topics.changeSource(mapObjectiveSource[$scope.state.inputs.objective])
    }

    $scope.generate = function() {
        let generateInputs = {
            inputs: {
                language: $scope.state.current.language,
                profile: $scope.state.current.profile,
                project: $scope.state.current.project,
                context: $scope.getContext(),
                needs: $scope.state.current.needs,
                goals: $scope.state.current.goals,
                audience: $scope.state.current.audience,
                area: $scope.state.current?.global?.area,
                category: $scope.state.current?.global?.category,
                focus: $scope.state.current?.global?.focus,
                mode: $scope.state.mode,
                multiple: true,
                amount: GENERATE_AMOUNT,
            },
            social: $scope.state.current.social
        }

        if ($scope.state.mode == 'media') {
            generateInputs.inputs.userMedias = ($scope.state.inputs.medias || []).slice(0, MAX_MEDIA_ITEMS)
        }
        if ($scope.state.mode == 'product') {
            generateInputs.inputs.products = ($scope.state.inputs.products || []).slice(0, MAX_MEDIA_ITEMS)
            generateInputs.inputs.productInputs = {
                objective: $scope.productInputs.objective.value == 'any' ? null : $scope.productInputs.objective.value,
            }
        }

        if ($scope.state.mode == 'link') {
            generateInputs.inputs.link = $scope.state.inputs.link
        }

        if ($scope.getExpanded() && $scope.state.inputs.shouldExpand == 'yes') {
            generateInputs.inputs.related = $scope.getExpanded()
        }

        if (modesWithIncludeProfile.includes($scope.state.mode) && $scope.state.inputs.includeProfile == 'no') {
            delete generateInputs.inputs.profile
            generateInputs.inputs.includeProfile = false
        }

        if (modesWithTones.includes($scope.state.mode)) {
            if ($scope.state.inputs.tone != 'normal' && objectivesWithTones.includes($scope.state.inputs.objective)) {
                generateInputs.inputs.tone = $scope.state.inputs.tone
            }
        }

        if (modesWithContentTypes.includes($scope.state.mode)) {
            let contentTypes = $scope.state.inputs[$scope.state.inputs.objective + '_content_type']
            if (contentTypes) {
                generateInputs.inputs.contentTypes = contentTypes
            }
            generateInputs.inputs.objective = $scope.state.inputs.objective
        }

        // Remove any field where its value is any
        generateInputs.inputs.layouts = {}
        for (let key in $scope.smartFilters.values) {
            if ($scope.smartFilters.values[key] != 'any') {
                generateInputs.inputs.layouts[key] = $scope.smartFilters.values[key]
            }
        }

        generateInputs.inputs.size = $scope.state.inputs.size

        function validateInputs() {
            if ($scope.state.mode == 'link' && (!$scope.state.inputs.link || $scope.state.inputs.link.trim() == '')) {
                showError(gettext('error.type_link'))
                return
            }
            if ($scope.state.mode == 'product' && (!$scope.state.inputs.products || $scope.state.inputs.products.length == 0)) {
                showError(gettext('error.select_product'))
                return false
            }
            if ($scope.state.mode == 'media' && (!$scope.state.inputs.medias || $scope.state.inputs.medias.length == 0)) {
                showError(gettext('error.select_media'))
                return false
            }
            if ($scope.state.mode == 'themes' && (!topics.getTopicsForGeneration() || topics.getTopicsForGeneration().length == 0)) {
                showError(gettext('error.select_themes'))
                return false
            }
            if ($scope.state.mode == 'instruction' && (!$scope.state.inputs.context || $scope.state.inputs.context.length == 0)) {
                showError(gettext('error.type_context'))
                return false
            }
            return true
        }

        if (!validateInputs()) {
            return
        }
        $scope.state.step = 'preview'
        _generator.generate(generateInputs)
    }

    $scope.showProductModal = function() {
        $scope.showMediaSelector('product', 'selectProducts', true)
    }

    $scope.getMediaStyle = function(media) {
        if (media.small) {
            return {
                'background-image': 'url(' + media.thumb + ')'
            }
        }
        return {
            'background-image': 'url(' + media.url + ')'
        }
    }

    $scope.showMediaModal = function() {
        let kind = 'image'
        let multiple = true
        if ($scope.state.mode == 'existing') {
            kind = $scope.state.inputs.mediaFormat
            if (kind == 'video') {
                multiple = false
            }
        }
        $scope.showMediaSelector(kind, 'selectMedias', multiple)
    }

    $scope.showMediaSelector = function(kind, source, multiple) {
        let mediaModalElement = angular.element('#images-modal');
        if (mediaModalElement) {
            mediaModalElement.modal('show')
            mediaModalElement.css('z-index', 100000)

            let sourceSpec = {
                name: source,
                origin: 'generator',
            }

            $rootScope.$broadcast('media.show', {
                source: sourceSpec,
                projectId: $scope.state.current.project,
                kind: kind,
                multiple: multiple,
            })
        }
    }

    $scope.deselectMedia = function(media) {
        if ($scope.state.mode == 'product') {
            $scope.state.inputs.products = $scope.state.inputs.products.filter(p => p._id != media._id)
        } else if ($scope.state.mode == 'media') {
            $scope.state.inputs.medias = $scope.state.inputs.medias.filter(p => p._id != media._id)
        } else if ($scope.state.mode == 'existing') {
            $scope.state.inputs.medias = $scope.state.inputs.medias.filter(p => p._id != media._id)
        }
    }

    $scope.deselectAll = function() {
        if ($scope.state.mode == 'product') {
            $scope.state.inputs.products = []
        } else if ($scope.state.mode == 'media') {
            $scope.state.inputs.medias = []
        }
    }

    $scope.toggleSelectAll = function(state) {
        _generator.toggleSelectAll(state)
        $timeout(angular.noop)
    }

    $scope.onPostFormatChange = function() {
        if ($scope.state.inputs.mediaFormat == 'video' && $scope.state.inputs.postFormat != 'reels') {
            $scope.state.inputs.postFormat = 'reels'
        }
        if ($scope.state.inputs.mediaFormat == 'image' && $scope.state.inputs.postFormat == 'reels') {
            $scope.state.inputs.postFormat = 'post'
        }
    }

    $scope.onMediaFormatChange = function() {
        $scope.onPostFormatChange()
        $scope.state.inputs.medias = []
    }

    $scope.stopGeneratingCaption = function() {
        if ($scope.state.captionsReader) {
            $scope.state.captionsReader.cancel()
        }
        $timeout(() => {
            $scope.state.captionsReader = null
        })
        $scope.generator.stopLoading()
    }

    $scope.clearCaptions = function() {
        $scope.state.inputs.captions = ''
    }

    $scope.generateCaption = function() {
        let hasStartedReader = false
        $scope.state.captionsReader = null
        $scope.generator.startLoading()
        $scope.generator.generateCaptions({
            text: $scope.state.inputs.captions_context,
        }, function(err, response, done, reader) {
            if (!$scope.state.captionsReader && !hasStartedReader) {
                $scope.state.captionsReader = reader
                hasStartedReader = true
            }
            $scope.state.inputs.captions = response
            if (err || done) {
                $scope.stopGeneratingCaption()
                return
            }
        })
    }

    $scope.createExistingPost = function() {
        // TOOD
        // Validate here
        if (!$scope.state.inputs.medias || $scope.state.inputs.medias.length == 0 || !$scope.state.inputs.postFormat) {
            showError(gettext('error.fill_required_fields'))
            return
        }
        if ($scope.state.inputs.postFormat == 'reels' && $scope.state.inputs.mediaFormat != 'video') {
            showError(gettext('error.format_post_not_support_media'))
            return
        }
        if ($scope.state.inputs.postFormat != 'reels' && $scope.state.inputs.mediaFormat != 'image') {
            showError(gettext('error.format_post_not_support_media'))
            return
        }
        if ($scope.state.inputs.postFormat != 'story' && !$scope.state.inputs?.captions?.trim().length) {
            showError(gettext('error.fill_required_fields'))
            return
        }

        let limitPerFormat = {
            'reels': 1,
            'story': 5,
            'post': 10,
        }

        if ($scope.state.inputs.medias.length > limitPerFormat[$scope.state.inputs.postFormat]) {
            showError(gettext('error.limit_posts_per_format'))
            return
        }

        let params = {
            calendar: {
                what: $scope.state.inputs.postFormat,
            }
        }
        if ($scope.state.inputs.captions) {
            params.caption = $scope.state.inputs.captions
        }
        if ($scope.state.current.selectedDate) {
            params.calendar.date = $scope.state.current.selectedDate
        }
        let medias = $scope.state.inputs.medias.map(function(media) {
            if (media.small) {
                return {
                    full: media.url,
                    small: media.small,
                    thumb: media.thumb,
                }
            }
            return media.url
        })

        $scope.generator.createExistingPost(
            medias.map(function(media) {
                return {
                    title: gettext('scratch.post1.title'),
                    layout: 'empty.no-bg',
                    image: media,
                }
            })
        , params)
    }

    $scope.save = function() {
        let params = {}
        if ($scope.state.mode == 'link') {
            params.link = $scope.state.inputs.link
        }
        _generator.save(params)
        .then(function(response) {
            $rootScope.$broadcast('generator.onNewPosts', {
                source: $scope.state.current.source,
                posts: _generator.getSelectedPosts(),
            })
            angular.element('#generator-modal').modal('hide')
            showSuccess(gettext('success.generic'))
        })
        .catch(function(error) {
            console.log('Error saving generator', error)
            if (error == 'dynamic_loading') {
                showError(gettext('error.imageLoading'))
                return
            }
            if (error == 'no_selection') {
                showError(gettext('error.select_a_post'))
                return
            }
            showError(gettext('error.save_posts'))
        })
    }
})